import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Search, ArrowRight } from "lucide-react";

export default function VerifySearch() {
    const [certificateId, setCertificateId] = useState("");
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!certificateId.trim()) return;
        navigate(`/verify/${certificateId.trim()}`);
    };

    return (
        <div className="min-h-screen bg-slate-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative overflow-hidden">
            {/* Background elements */}
            <div className="absolute top-0 left-0 right-0 h-96 bg-gradient-to-b from-primary/10 to-transparent pointer-events-none" />
            <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl pointer-events-none" />

            <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10 text-center">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary border border-primary/20 mb-6">
                    <img src="/logo.png" alt="ParshHR Logo" className="w-4 h-4 object-contain" />
                    <span className="text-xs font-semibold uppercase tracking-wider">ParshWebCraft HR</span>
                </div>
                <h2 className="text-3xl sm:text-4xl font-heading font-extrabold text-white tracking-tight">
                    Document Verification Portal
                </h2>
                <p className="mt-2 text-sm text-slate-400">
                    Verify the authenticity of internship certificates, LORs, and offer letters.
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md relative z-10">
                <div className="bg-slate-800/80 backdrop-blur-xl border border-slate-700 py-8 px-4 shadow-2xl rounded-3xl sm:px-10">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="certId" className="block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">
                                Certificate / Document ID
                            </label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <Search className="h-5 w-5 text-slate-500" />
                                </div>
                                <input
                                    id="certId"
                                    name="certId"
                                    type="text"
                                    required
                                    placeholder="e.g. PWC-INT-2026-001"
                                    value={certificateId}
                                    onChange={(e) => setCertificateId(e.target.value)}
                                    className="block w-full pl-10 pr-3 py-3 border border-slate-700 rounded-xl bg-slate-900/50 text-white placeholder-slate-500 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition"
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center items-center gap-2 bg-primary hover:bg-primary-hover text-white py-3 px-4 rounded-xl text-sm font-semibold shadow-lg transition duration-300 transform active:scale-[0.98]"
                            >
                                <ShieldCheck className="w-4 h-4" />
                                <span>Verify Document</span>
                                <ArrowRight className="w-4 h-4" />
                            </button>
                        </div>
                    </form>
                </div>
                
                <p className="mt-6 text-center text-xs text-slate-500">
                    Verification logging is active. Every query is logged for audit purposes.
                </p>
            </div>
        </div>
    );
}
